export function dataInRequest(params = {}) {
  return {
    type: '@mensagemSistemaEquipamento/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagemSistemaEquipamento/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagemSistemaEquipamento/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagemSistemaEquipamento/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagemSistemaEquipamento/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagemSistemaEquipamento/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagemSistemaEquipamento/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagemSistemaEquipamento/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagemSistemaEquipamento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagemSistemaEquipamento/RECORD_FILTERING',
    payload: { params },
  };
}
